"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Query = void 0;
// TODO: Refine Query typings
/**
 * @see https://developers.prezly.com/docs/api/docs/06-prezly-query-language.md
 */
let Query = exports.Query = void 0;
(function (_Query) {
  function stringify(query) {
    if (!query) {
      return undefined;
    }
    return typeof query === 'string' ? query : JSON.stringify(query);
  }
  _Query.stringify = stringify;
})(Query || (exports.Query = Query = {}));